import { Injectable } from '@angular/core';
import {FormGroup,FormControl,Validator} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class PedidosService {

  constructor() { }

  form: FormGroup = new FormGroup({
    id_pedido : new FormControl(null),
    id_usuario : new FormControl(''),
    servicio : new FormControl(''),
    cod : new FormControl(''),
    retorno : new FormControl(''),
    fechaRecojo : new FormControl(''),
    horaRecojo : new FormControl(''),
    observaciones_recojo : new FormControl(''),
    fechaEntrega : new FormControl(''),
    horaEntrega : new FormControl(''),
    observaciones_entrega : new FormControl(''),
    lugarRecojo : new FormControl(''),
    lugarEntrega : new FormControl(''),
    descripcion : new FormControl(''),
    estado : new FormControl(''),
    precio : new FormControl(''),
    tipoPago : new FormControl(''),
    RUCFactura : new FormControl(''),
    RazonSocialFactura : new FormControl(''),
    fecha_por_atender : new FormControl(''),
    fecha_recogido : new FormControl(''),
    fecha_entregado : new FormControl(''),
    fecha_devolucion : new FormControl(''),
    fecha_anulado : new FormControl(''),
    liquidado : new FormControl(''),
    created_at : new FormControl(''),
    updated_at : new FormControl(''),
  });


}
